const prodEnv = require('../../config/prod.env')

export default {
  // 测试
  // ImageUrl: "http://192.168.5.201:8080/", // 测试
  // jumpUrlPJBS: "http://192.168.5.201:8080/GB-aprsLabel/#/whiteList", // 跳转评价标识测试环境
  // jumpUrlPJBS: "http://117.74.136.106:18807/#/whiteList", // 跳转评价标识生产环境

  // jumpUrlJKJZ: "http://192.168.5.201:8080/healthy-building/#/whiteList", // 跳转健康建筑测试环境
  // jumpUrlJKJZ: "http://117.74.136.106:18809/#/whiteList", // 跳转健康建筑生产环境

  // jumpUrlSTCQ: "http://192.168.5.201:8080/eco-city/#/whiteList" // 跳转生态城区测试环境


  // 生产
  ImageUrl: 'http://117.74.136.106:18808/',
  jumpUrlPJBS: 'http://117.74.136.106:18807/#/whiteList', // 跳转评价标识生产环境
  jumpUrlJKJZ: 'http://117.74.136.106:18809/#/whiteList', // 跳转健康建筑生产环境
  jumpUrlSTCQ: "http://117.74.136.106:18810/#/whiteList" // 跳转生态城区测试环境
};










// WEBPACK FOOTER //
// ./src/constant/index.js